<div class="asset-team-container">
  <app-back-button></app-back-button>
  <app-loader class="loader" *ngIf="loaderView"></app-loader>
  <div class="wrapper-container" *ngIf="!loaderView">
    <div class="asset-container">
      <div>
        <div>
          <div class="head">
            <h1 class="heading">{{ pageTitle }}</h1>
            <button *ngIf="!accessoryTypeId" class="close-button" type="button" (click)="closeConfirmationDialog()">
              <img src="assets/24x24/close.svg" alt="" />
            </button>
            <button *ngIf="accessoryTypeId" class="close-button" type="button" (click)="backToDetails()">
              <img src="assets/24x24/close.svg" alt="" />
            </button>
          </div>
          <p class="info">
            {{
            accessoryId
            ? "Edit and update specifications of selected accessory"
            : "Select an accessory category and specifications to add a new accessory"
            }}
          </p>
          <p class="note">Fields marked with<span class="required-star"> * </span>are mandatory</p>
        </div>
        <!-- Create Asset Form starts here -->
        <div>
          <form [formGroup]="accessoryForm">
            <div class="form-group">
              <div class="header-container">
                <ng-container>
                  <div class="dropdown">
                    <p class="label">Category <span class="required-star"> * </span></p>
                    <app-generic-drop-down [options]="accessoryTypeOptions" (value)="getValueOfCategory($event)"
                      selectedValue="" [titleName]="'name'" [valueName]="'id'"
                      [title]="selectedValue || 'Select Accessory Category'" [shouldEmitEmittedValue]="true"
                      [disabled]="!!accessoryId || isCategorySelected">
                    </app-generic-drop-down>
                  </div>
                </ng-container>
                <ng-container *ngIf="accessoryTypeId">

                  <div class="field">
                    <p for="" class="label">Accessory Name <span class="required-star"> * </span></p>
                    <app-text-field [required]="true" for="name" id="name" type="text" [formControlName]="'name'"
                      label="" placeholder="Enter Accessory Name" [hasError]="''"></app-text-field>
                    <!-- Validation Error -->
                    <span *ngIf="
                        accessoryForm.get('name')?.errors?.['required'] &&
                        (accessoryForm.get('name')?.touched ||
                          accessoryForm.get('name')?.dirty)
                      " class="error-message">
                      This field is mandatory.
                    </span>
                    <span *ngIf="
                        accessoryForm.get('name')?.errors?.['pattern'] &&
                        (accessoryForm.get('name')?.touched ||
                          accessoryForm.get('name')?.dirty)
                          " class="error-message">
                      Do not enter special symbols
                    </span>
                  </div>

                  <div class="field">
                    <p for="" class="label">Quantity <span class="required-star"> * </span></p>
                    <app-text-field [required]="true" for="quantity" id="quantity" type="number"
                      [formControlName]="'quantity'" label="" placeholder="Enter Quantity" [hasError]="accessoryForm.get('quantity')?.errors && (accessoryForm.get('quantity')?.touched ||
                          accessoryForm.get('quantity')?.dirty)" maxlength="5"
                      (keydown)="preventMoreThanFiveDigits($event)"></app-text-field>
                    <!-- Validation Error -->
                    <span class="error-message">{{quantityError}}</span>
                    <span *ngIf="
                        accessoryForm.get('quantity')?.errors?.['required'] &&
                        (accessoryForm.get('quantity')?.touched ||
                          accessoryForm.get('quantity')?.dirty)
                      " class="error-message">
                      This field is mandatory.
                    </span>
                    <span *ngIf="
                          accessoryForm.get('quantity')?.errors?.['maxlength'] &&
                          (accessoryForm.get('quantity')?.touched ||
                          accessoryForm.get('quantity')?.dirty)
                          " class="error-message">
                      Please don't enter more than 5 digits
                    </span>
                    <span *ngIf="
                          accessoryForm.get('quantity')?.errors?.['pattern'] &&
                          (accessoryForm.get('quantity')?.touched ||
                          accessoryForm.get('quantity')?.dirty)
                          " class="error-message">
                      Please don't enter negative digits
                    </span>
                  </div>

                  <div class="field">
                    <p class="label">Purchase Date <span class="required-star"> * </span></p>
                    <app-text-field [formControlName]="'purchaseDate'" [required]="true" for="purchaseDate"
                      id="purchaseDate" type="date" [max]="maxDate" label="" [value]="properties['purchaseDate']"
                      [hasError]="" [placeholder]="'dd-MM-yyyy'">
                    </app-text-field>
                    <!-- Validation Error -->
                    <small *ngIf="
                        accessoryForm.get('purchaseDate')?.invalid &&
                        (accessoryForm.get('purchaseDate')?.touched ||
                          accessoryForm.get('purchaseDate')?.dirty)
                      " class="error-message">
                      This field is mandatory.
                    </small>
                  </div>
                </ng-container>
              </div>
              <hr *ngIf="accessoryTypeId && accessoryTypeData['categories'].length!==0" />
              <ng-container *ngIf="accessoryTypeId">
                <div *ngFor="let category of accessoryTypeData['categories']; let i = index; let last = last">
                  <h3 class="title">{{ category.displayName }}</h3>
                  <div class="categories-section">
                    <ng-container class="categories-info" *ngFor="let config of getConfigsByCategory(category.name)">
                      <div *ngIf="config.displayName !== 'Purchase Date'">
                        <label class="label">{{ config.displayName }}<span class="required-star" *ngIf="config.isRequired"> * </span></label>
                        <div class="property-field">
                          <app-text-field *ngIf="!config.list" [type]="
                            config.valueType === 'number' ? 'number' : 'text'
                          " [placeholder]="'Enter ' + config.displayName" [required]="config.isRequired"
                            [formControlName]="config.name" [value]="properties[config.name]">
                          </app-text-field>
                          <app-generic-drop-down *ngIf="config.list" [label]="config.displayName"
                            [options]="config.values" [title]="
                            properties[config.name] ||
                            'Select ' + config.displayName
                          " (value)="
                            properties[config.name] = $event;
                            onSelectionChange($event, config.name)
                          " [valueName]="'unit'" [shouldEmitOption]="true"></app-generic-drop-down>

                          <app-generic-drop-down *ngIf="config.units && config.units.length"
                            [label]="config.displayName + ' Unit'" [options]="config.units" [title]="
                            properties[config.name + 'Unit'] ||
                            'Select ' + config.displayName + ' Unit'
                          " (value)="
                            properties[config.name + 'Unit'] = $event;
                            onSelectionChange($event, config.name + 'Unit')
                          " [shouldEmitOption]="true"></app-generic-drop-down>
                        </div>
                        <!-- Validation Error -->
                        <small *ngIf="
                          config.isRequired &&
                          accessoryForm.get(config.name)?.invalid &&
                          (accessoryForm.get(config.name)?.touched ||
                            accessoryForm.get(config.name)?.dirty)
                        " class="error-message">
                          This field is mandatory.
                        </small>
                      </div>
                    </ng-container>
                  </div>

                  <hr *ngIf="!last" />
                </div>
                <div class="button">
                  <app-button class="spacing" type="submit" size="medium" theme="primary"
                    [disabled]="accessoryForm.invalid" (click)="showAddAccessoryConfirmationDialog()">{{ accessoryId ?
                    "Update" : "Add" }}
                  </app-button>
                </div>
              </ng-container>
            </div>
          </form>
        </div>
      </div>

      <!-- Form ends here -->
    </div>
  </div>
</div>